import { render, staticRenderFns } from "./NoRecord.vue?vue&type=template&id=20b7d016&scoped=true"
import script from "./NoRecord.vue?vue&type=script&lang=js"
export * from "./NoRecord.vue?vue&type=script&lang=js"
import style0 from "./NoRecord.vue?vue&type=style&index=0&id=20b7d016&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b7d016",
  null
  
)

export default component.exports